import { render, staticRenderFns } from "./bet-dice-market-section.vue?vue&type=template&id=e51de9fc&scoped=true"
import script from "./bet-dice-market-section.vue?vue&type=script&lang=js"
export * from "./bet-dice-market-section.vue?vue&type=script&lang=js"
import style0 from "./bet-dice-market-section.vue?vue&type=style&index=0&id=e51de9fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51de9fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e51de9fc')) {
      api.createRecord('e51de9fc', component.options)
    } else {
      api.reload('e51de9fc', component.options)
    }
    module.hot.accept("./bet-dice-market-section.vue?vue&type=template&id=e51de9fc&scoped=true", function () {
      api.rerender('e51de9fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/bet-dice-market-section.vue"
export default component.exports